var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMouse = function SvgIconMouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.875 2a6.25 6.25 0 0 1 6.25 6.25v7.5a6.25 6.25 0 0 1-6.25 6.25h-3.75a6.25 6.25 0 0 1-6.25-6.25v-7.5A6.25 6.25 0 0 1 10.125 2zm-3.75 2a4.25 4.25 0 0 0-4.25 4.25V9.5H11V4zM13 4v5.5h5.125V8.25A4.25 4.25 0 0 0 13.875 4zm-7.125 7.5v4.25a4.25 4.25 0 0 0 4.25 4.25h3.75a4.25 4.25 0 0 0 4.25-4.25V11.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconMouse;